/**
 * BrandingIcons.jsx
 * Created by Destin Frasier on 10/05/17.
 */

import BrandingIconSingleton from './brandingIconSingleton';
import BaseIcon from '../BaseIcon';


class BrandingIcon extends BaseIcon {
    constructor(props) {
        super(props);
        this.iconSingleton = BrandingIconSingleton;
    }
}

export class Logo extends BrandingIcon {}
Logo.defaultProps = {
    iconName: 'rec-icon-logo',
    iconClass: 'rec-icon-logo'
};

export class LogoLight extends BrandingIcon {}
LogoLight.defaultProps = {
    iconName: 'rec-icon-logo',
    iconClass: 'rec-icon-logo-light'
};

export class Compass extends BrandingIcon {}
Compass.defaultProps = {
    iconName: 'rec-icon-compass',
    iconClass: 'rec-icon-compass'
};

export class CompassSolid extends BrandingIcon {}
CompassSolid.defaultProps = {
    iconName: 'rec-icon-compass-solid',
    iconClass: 'rec-icon-compass-solid'
};

export class Tree extends BrandingIcon {}
Tree.defaultProps = {
    iconName: 'rec-icon-tree',
    iconClass: 'rec-icon-tree'
};

export class Trees extends BrandingIcon {}
Trees.defaultProps = {
    iconName: 'rec-icon-trees',
    iconClass: 'rec-icon-trees'
};

export class Tent extends BrandingIcon {}
Tent.defaultProps = {
    iconName: 'rec-icon-tent',
    iconClass: 'rec-icon-tent'
};

export class Lottery extends BrandingIcon {}
Lottery.defaultProps = {
    iconName: 'rec-icon-lottery',
    iconClass: 'rec-icon-lottery'
};

export class TentCircle extends BrandingIcon {}
TentCircle.defaultProps = {
    iconName: 'rec-icon-tent-circle',
    iconClass: 'rec-icon-tent-circle'
};

export class Tour extends BrandingIcon {}
Tour.defaultProps = {
    iconName: 'rec-icon-tour',
    iconClass: 'rec-icon-tour'
};

export class TourCircle extends BrandingIcon {}
TourCircle.defaultProps = {
    iconName: 'rec-icon-tour-circle',
    iconClass: 'rec-icon-tour-circle'
};

export class Hike extends BrandingIcon {}
Hike.defaultProps = {
    iconName: 'rec-icon-hike',
    iconClass: 'rec-icon-hike'
};

export class HikeCircle extends BrandingIcon {}
HikeCircle.defaultProps = {
    iconName: 'rec-icon-hike-circle',
    iconClass: 'rec-icon-hike-circle'
};

export class Users extends BrandingIcon {}
Users.defaultProps = {
    iconName: 'rec-icon-users',
    iconClass: 'rec-icon-users'
};

export class Locations extends BrandingIcon {}
Locations.defaultProps = {
    iconName: 'rec-icon-locations',
    iconClass: 'rec-icon-locations'
};

export class DigitalPass extends BrandingIcon {}
DigitalPass.defaultProps = {
    iconName: 'rec-icon-digital-pass',
    iconClass: 'rec-icon-digital-pass'
};

export class Activities extends BrandingIcon {}
Activities.defaultProps = {
    iconName: 'rec-icon-activities',
    iconClass: 'rec-icon-activities'
};

export class Camping extends BrandingIcon {}
Camping.defaultProps = {
    iconName: 'rec-icon-camping',
    iconClass: 'rec-icon-camping'
};

export class Picnicking extends BrandingIcon {}
Picnicking.defaultProps = {
    iconName: 'rec-icon-picnicking',
    iconClass: 'rec-icon-picnicking'
};

export class Hiking extends BrandingIcon {}
Hiking.defaultProps = {
    iconName: 'rec-icon-hiking',
    iconClass: 'rec-icon-hiking'
};

export class Rafting extends BrandingIcon {}
Rafting.defaultProps = {
    iconName: 'rec-icon-rafting',
    iconClass: 'rec-icon-rafting'
};

export class Ranger extends BrandingIcon {}
Ranger.defaultProps = {
    iconName: 'rec-icon-ranger',
    iconClass: 'rec-icon-ranger'
};

export class HistoricTour extends BrandingIcon {}
HistoricTour.defaultProps = {
    iconName: 'rec-icon-historic-tour',
    iconClass: 'rec-icon-historic-tour'
};

export class RV extends BrandingIcon {}
RV.defaultProps = {
    iconName: 'rec-icon-rv',
    iconClass: 'rec-icon-rv'
};

export class Binoculars extends BrandingIcon {}
Binoculars.defaultProps = {
    iconName: 'rec-icon-binoculars',
    iconClass: 'rec-icon-binoculars'
};

export class Events extends BrandingIcon {}
Events.defaultProps = {
    iconName: 'rec-icon-events',
    iconClass: 'rec-icon-events'
};

export class Hunting extends BrandingIcon {}
Hunting.defaultProps = {
    iconName: 'rec-icon-hunting',
    iconClass: 'rec-icon-hunting'
};

export class Biking extends BrandingIcon {}
Biking.defaultProps = {
    iconName: 'rec-icon-biking',
    iconClass: 'rec-icon-biking'
};

export class Lodging extends BrandingIcon {}
Lodging.defaultProps = {
    iconName: 'rec-icon-lodging',
    iconClass: 'rec-icon-lodging'
};

export class Riding extends BrandingIcon {}
Riding.defaultProps = {
    iconName: 'rec-icon-riding',
    iconClass: 'rec-icon-riding'
};

export class HorsebackRiding extends BrandingIcon {}
HorsebackRiding.defaultProps = {
    iconName: 'rec-icon-horseback-riding',
    iconClass: 'rec-icon-horseback-riding'
};

export class Boating extends BrandingIcon {}
Boating.defaultProps = {
    iconName: 'rec-icon-boating',
    iconClass: 'rec-icon-boating'
};

export class FourHundredError extends BrandingIcon {}
FourHundredError.defaultProps = {
    iconName: 'rec-icon-400-error',
    iconClass: 'rec-icon-400-error'
};

export class FourZeroThreeError extends BrandingIcon {}
FourZeroThreeError.defaultProps = {
    iconName: 'rec-icon-403-error',
    iconClass: 'rec-icon-403-error'
};

export class FourZeroFourError extends BrandingIcon {}
FourZeroFourError.defaultProps = {
    iconName: 'rec-icon-404-error',
    iconClass: 'rec-icon-404-error'
};

export class FiveHundredError extends BrandingIcon {}
FiveHundredError.defaultProps = {
    iconName: 'rec-icon-500-error',
    iconClass: 'rec-icon-500-error'
};

export class HomepageTent extends BrandingIcon {}
HomepageTent.defaultProps = {
    iconName: 'rec-icon-homepage-tent',
    iconClass: 'rec-icon-homepage-tent'
};

export class HomepageSign extends BrandingIcon {}
HomepageSign.defaultProps = {
    iconName: 'rec-icon-homepage-sign',
    iconClass: 'rec-icon-homepage-sign'
};

export class HomepageCanoe extends BrandingIcon {}
HomepageCanoe.defaultProps = {
    iconName: 'rec-icon-homepage-canoe',
    iconClass: 'rec-icon-homepage-canoe'
};

export class HomepageHunting extends BrandingIcon {}
HomepageHunting.defaultProps = {
    iconName: 'rec-icon-homepage-hunting',
    iconClass: 'rec-icon-homepage-hunting'
};
